import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useAthleteContext } from '../../context/AthleteContext';
import { NmLoadingOverlay } from '../../components/NmLoadingOverlay';
const AiAssistantPage = React.lazy(() => import('../../pages/AiAssistantPage').then(module => ({ default: module.AiAssistantPage })));
export function MobileAiAssistantPage() {
  const { user } = useAuth();
  const { selectAthlete } = useAthleteContext();
  const navigate = useNavigate();
  return <React.Suspense fallback={<NmLoadingOverlay />}><AiAssistantPage user={user} onOpenWorkout={(id, date, athleteId) => {
    if (athleteId) selectAthlete(athleteId);
    const params = new URLSearchParams({ workoutId: String(id) });
    if (date) params.set('date', date);
    navigate(`/calendar?${params}`);
  }} /></React.Suspense>;
}
